import { FunctionComponent, useCallback, useState } from "react";
import { setCookie, CookieKeys } from "@lib/cookies";
import { selectClient } from "@store/client/clientReducer";
import { useAppSelector } from "@store/store";
import { Trans, useTranslation } from "react-i18next";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { TabButton } from "@ui-kit/TabButton/TabButton";
import { Text } from "@ui-kit/Text/Text";

import "./GdprCookieBanner.css";
import { Banner } from "../Banner/Banner";

const GdprCookieBanner: FunctionComponent = () => {
  const [hasConsent, setHasConsent] = useState(false);
  const client = useAppSelector(selectClient)!;
  const { t } = useTranslation();
  const { isMobile } = useWindowSize();

  const onAccept = useCallback(() => {
    setCookie(CookieKeys.hasConsent, "true", 365);
    setHasConsent(true);
  }, []);

  if (hasConsent) {
    return null;
  }

  return (
    <Banner
      className={`gdpr-banner ${isMobile ? "gdpr-banner-mobile" : ""}`}
      testId="gdpr-cookie-banner">
      <Text variant="fontBodyMedium">
        <Trans
          i18nKey="gdprCookieBanner.description"
          components={{
            a: (
              <a
                href={client.privacyPolicyUrl}
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      </Text>
      <TabButton
        variant="inverse"
        onPress={onAccept}
        label={t("gdprCookieBanner.accept")}
        size="large"
        active={true}
      />
    </Banner>
  );
};

export { GdprCookieBanner };
